<template>
  <AccountantsSubmenu
    :items="menuItems"
  >
    <template v-slot:titletop>
      <!-- <GekkoButton
        :text="$gettext('Add customer')"
        icon="fa-solid fa-plus"
        class="position-relative"
        size="lg"
      /> -->
    </template>
    <template v-slot:bottom>
    </template>
  </AccountantsSubmenu>
</template>

<script>
import AccountantsSubmenu from '@/components/accountants/AccountantsSubmenu.vue'
import GekkoButton from "@/components/GekkoButton";

export default {
  name: 'AccountantsCustomersMenu',
  components: { 
    AccountantsSubmenu,
    GekkoButton
  },
  computed: {
    menuItems() {
      return [
        {
          key: 'customers',
          label: this.$gettext('All customers'),
          name: 'Customers',
          icon: 'fa-users',
        },
        {
          key: 'pending',
          label: this.$gettext('Pending invitations'),
          name: 'PendingInvitations',
          icon: 'fa-clock',
        },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
</style>
